import { render, staticRenderFns } from "./channelDataloader.vue?vue&type=template&id=6624a637"
import script from "./channelDataloader.vue?vue&type=script&lang=js"
export * from "./channelDataloader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports